import { /*useEffect,*/ useState } from 'react';
import Loading from 'components/Loading';
import axios from 'axios';
import { Button, TextField } from '@mui/material';

const Q_API = "https://nodejs-back-green.afinidata.com/v1/newsletter"
// const Q_API = "http://127.0.0.1:6768/v1/queries"




const NewsletterExtraction = (props: any) => {
    const [loading, setLoading] = useState<boolean>(false);

    const [content, setContent] = useState<any>("");
    const [fileName, setFileName] = useState("");

    const handleFileUpload = (event:any) => {
        const file = event.target.files[0];

        if (file && file.type === "text/html") {
        const reader = new FileReader();
        reader.onload = (e) => {
            setContent(e?.target?.result); // raw HTML text
            setFileName(file.name)
        };
        reader.readAsText(file);
        } else {
        alert("Please upload a valid .html file");
        }
    };
    const sendFile = async () => {
        setLoading(true)
        console.log('starting wait')
        await axios.post(`${Q_API}`,{html:content});
        console.log('ended wating')
        setLoading(false)
    }
    if( loading ){
        return (
        <>
            <h4 className="card-title">El servidor esta trabajando espera 5 minutos</h4>
            <h5 className="card-title">Podras ver <a target="_blank"  href="https://docs.google.com/spreadsheets/d/1VfTcD33KUs14nDP4YPNER8RorNsp2EfGujqyDuxwHIQ">aqui</a> cuando termine</h5>
            <Loading />
        </>
        )
    }

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-xs-12 col-md-6">
                            <h4 className="card-title">Extraer de Newsletter</h4>
                        </div>
                    </div>
                    <text>
                        Cómo descargar el HTML del newsletter:
                    </text>
                    <ol>
                        <li>Abre el correo donde recibiste el newsletter.</li>
                        <li>Haz clic en el título del artículo (esto te llevará a la página de Substack).</li>
                        <li>Una vez en la página de Substack, haz clic derecho en cualquier parte de la página.</li>
                        <li>Selecciona la opción “Guardar como…” (Save as…).</li>
                        <li>En la ventana que aparece, asegúrate de elegir el tipo “Página web, completa” (Webpage, complete) para que guarde el HTML con todos sus recursos.</li>
                        <li>Elige una carpeta en tu computadora y guarda el archivo.</li>

                    </ol>
                    <div style={{display:'flex'}}>
                        <TextField
                            label="Nombre del html"
                            value={fileName}
                            fullWidth
                            style={{margin:10}}
                            />

                        <Button fullWidth variant="contained" component="label" style={{margin:10}}>
                            Elegir archivo
                            <input type="file" hidden accept='.html' onChange={handleFileUpload} />
                        </Button>

                    </div>

                    <Button fullWidth variant="contained" component="label" style={{margin:10}} onClick={sendFile} disabled={fileName==""}>
                        Extraer info
                    </Button>
                </div>
            </div>
        </>
    )
}

export default NewsletterExtraction

